// extracted by extract-css-chunks-webpack-plugin
module.exports = {"loader":"button__loader--6QS2K","content":"button__content--2ECMT","loading":"button__loading--3HB9_"};